// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3YBsi","question":"styles_question__CwO0o","description":"styles_description__249vC"};